/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyType } from '../../models/key-type';
import { OrganizationSite } from '../../models/organization-site';

export interface GetAdministrationOrganizationSites$Params {

/**
 * The organization key
 */
  organizationKey: KeyType;
}

export function getAdministrationOrganizationSites(http: HttpClient, rootUrl: string, params: GetAdministrationOrganizationSites$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<OrganizationSite>>> {
  const rb = new RequestBuilder(rootUrl, getAdministrationOrganizationSites.PATH, 'get');
  if (params) {
    rb.path('organizationKey', params.organizationKey, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<OrganizationSite>>;
    })
  );
}

getAdministrationOrganizationSites.PATH = '/administration/organizations/{organizationKey}/organization-sites';
